(function ($) {

    $(window).load(function () {
        var wrap = $('#popup_overlay'),
            behavior = wrap.attr('data-behavior');
        if (behavior === 'window_load') {
            var visited = $.cookie('visited');
            if (visited === 'yes') {
                // second page load, cookie active
            } else {
                popUp();
            }
            $.cookie('visited', 'yes', {
                expires: Number(expire_days_cookie_popup)
            });
        }

    });

    function onMouseOut(event) {
        // If the mouse is near the top of the window, show the popup
        // Also, do NOT trigger when hovering or clicking on selects
        var wrap = $('#popup_overlay'),
            behavior = wrap.attr('data-behavior');
        if (behavior === 'window_close' &&
            event.clientY < 2 &&
            event.relatedTarget == null &&
            event.target.nodeName.toLowerCase() !== 'select') {
            // Remove this event listener
            document.removeEventListener("mouseout", onMouseOut);

            // Show the popup
            var visited = $.cookie('visited');
            if (visited === 'yes') {
                // second page load, cookie active
            } else {
                popUp();
            }
            $.cookie('visited', 'yes', {
                expires: Number(expire_days_cookie_popup)
            });
        }
    }

    document.addEventListener("mouseout", onMouseOut);

    function popUp() {
        var wrap = $('#popup_overlay');
        $('body').prepend(wrap);

        if (wrap.length > 0) {
            $('html').addClass('no_scroll');
            wrap.fadeIn();
            centerPopUp();
            wrap.attr('aria-modal', true);
            wrap.removeAttr("tabindex");
            wrap.find('.close_popup').focus();
            wrap.find('.content_wrap a').last().focusout(function (){
                wrap.find('.close_popup').focus();
            });
            wrap.find('.close_popup').click(function () {
                wrap.fadeOut('fast');
                $('html').removeClass('no_scroll');
                wrap.attr('aria-modal', false);
                wrap.attr("tabindex",-1);
            });
        }
    }
    function centerPopUp() {
        var wrap = $('#popup');
        if (wrap.length > 0) {
            var wh = jQuery(window).height(),
                wrapH = wrap.height();
            if (wrapH > wh) {
                wrap.addClass('not-centered');
            }
            window.addEventListener('resize', function(event) {
                if (wrapH > wh) {
                    wrap.addClass('not-centered');
                }
            });
        }
    }

}(jQuery));

